// extracted by mini-css-extract-plugin
export var content = "_9p-3";
export var list = "_9p-4";
export var settingsContent = "_9p-7";
export var settingsPanel = "_9p-8";
export var state = "_9p-6";
export var triggerBadge = "_9p-2";
export var triggerButton = "_9p-1";
export var triggerShell = "_9p-0";
export var unreadDot = "_9p-5";